/**
 * 작업소요 모달 (BS)
 */
import Util from '../../../Common/Util';

export default class HowLongWindow {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }
    /**
     * work_time 기준으로 g5_worktime 에서 available_times 를 산출
     * @param data ORDER 데이터 (work_time, car_type, order_sosok 사용)
     */
    calcAvailableTimes = function(data){
        const car_type = data?.['car_type'] || '';
        const work_time = data?.['work_time'] || '';
        const sosok = data?.['order_sosok'] || '';

        let hm = '';
        if( work_time ){
            const d = dayjs(work_time);
            if( d.isValid() ) hm = d.format('HHmm');
        }

        let available = '';
        const table = window.G5_WORKTIME || [];
        for( const row of table ){
            if( String(row.start_hm)<=hm && hm<=String(row.end_hm)){
                available = row.available_times || '';
                break;
            }
        }
        if( Util.isSosokSamsung(sosok) && '1700'<=hm && hm<='1759'){
            available = '시간';
        }
        if( car_type=='사다리' && available.indexOf('시간')===-1){
            available = available ? available+',시간' : '시간';
        }
        if( car_type=='리프트') available = '일';
        return available;
    }
    /**
     * 소요시간 모달 HTML
     */
    getHtml = function(data){
        const car_type = data?.['car_type'] || '';
        const available_times = this.calcAvailableTimes(data);

        const standardSection = (car_type=='사다리') ? `
        <p class="info_txt">선택하신 기준(물량/시간)에 따라 작업단가가 변경됩니다</p>
        <div class="standard_box">
            <div class="standard_btn" data-value="t">
                <h4>물량(톤) 기준</h4>
                <p>이삿짐(가전/가구)인 경우 선택</p>
            </div>
            <div class="standard_btn" data-value="h">
                <h4>시간 기준</h4>
                <p>현장작업인 경우 선택</p>
            </div>
        </div>
        <div class="weight_box">
            <div class="item flex number-font _ton_" data-value="1,톤">1<span class="fz_11 fw_medium mt-05  mt-4">톤짐</span></div>
            <div class="item flex number-font _ton_" data-value="2.5,톤">2.5<span class="fz_11 fw_medium mt-05  mt-4">톤짐</span></div>
            <div class="item flex number-font _ton_" data-value="5,톤">5<span class="fz_11 fw_medium mt-05  mt-4">톤짐</span></div>
            <div class="item flex number-font _ton_" data-value="6,톤">6<span class="fz_11 fw_medium mt-05  mt-4">톤짐</span></div>
            <a href="#" class="item flex _ton_ fz_12 more-open" data-pop="more_ton_pop" data-title="톤짐">더보기</a>
        </div>
        <div class="line weight_line"></div>` : '';

        const dayBoxLift = `
        <div class="title title2">일</div>
        <div class="flex item _day_" data-value="1,일">1일 </div>
        <div class="flex item _day_" data-value="2,일">2일</div>
        <div class="flex item _day_" data-value="3,일">3일</div>
        <div class="flex item _day_" data-value="4,일">4일</div>
        <a href="#" class="item flex _day_ fz_12 more-open" data-pop="more_day_pop" data-title="일 · 월대">더보기</a>

        <div class="title title2">월대</div>
        <div class="flex item _day_" data-value="1,월">1개월</div>
        <div class="flex item _day_" data-value="2,월">2개월</div>
        <div class="flex item _day_" data-value="3,월">3개월</div>
        <div class="flex item _day_" data-value="4,월">4개월</div>
        <a href="#" class="item flex _day_ fz_12 more-open" data-pop="more_day_pop" data-title="일 · 월대">더보기</a>`;

        // 시간·야간 버튼. 글자는 장비별로 부르고(지게차는 분 — $j.F.Car.hourLabel),
        // data-value 는 시간 그대로 둔다 — 저장값·단가가 시간 기준이다.
        const hourBtn = (i, type, cls) => {
            const [, num, unit] = $j.F.Car.hourLabel(i, car_type).match(/^(\d+)(\D+)$/);
            return `<div class="item flex number-font ${cls}" data-value="${i},${type}">${num}<span class="fz_11 fw_medium mt-05  mt-4">${unit}</span></div>`;
        };

        const dayBoxNormal = `
        <div class="day_box">
            <div class="title title2">일</div>
            <div class="flex item _day_" data-value="1,일">1일</div>
            <div class="flex item _day_" data-value="2,일">2일</div>
            <div class="flex item _day_" data-value="3,일">3일</div>
            <div class="flex item _day_" data-value="1,월">월대</div>
            <a href="#" class="item flex _day_ fz_12 more-open" data-pop="more_day_pop" data-title="일 · 월대">더보기</a>

            <div class="title title2">반나절</div>
            <div class="item af flex">
                <div class="flex item _half_" data-value="4,오전">오전</div>
                <div class="flex item _half_" data-value="4,오후">오후</div>
            </div>

            <div class="title title3">시간</div>
            ${[1, 2, 3, 4].map((i) => hourBtn(i, '시간', '_hour_')).join('')}
            <a href="#" class="item flex _hour_ fz_12 more-open" data-pop="more_hour_pop" data-title="시간">더보기</a>

            <div class="title title3">야간</div>
            ${[1, 2, 3, 4].map((i) => hourBtn(i, '야간', '_night_')).join('')}
            <a href="#" class="item flex _night_ fz_12 more-open" data-pop="more_night_pop" data-title="야간">더보기</a>
        </div>`;

        const dayBoxSection = (car_type=='리프트') ? dayBoxLift : dayBoxNormal;

        const moreDayItems = (() => {
            let h = '';
            for( let i=1; i<=25; i++) h += `<div class="item flex _day_" data-value="${i},일">${i}일</div>`;
            const months = [
                ['1,월','월대'], ['2,월','2개월'], ['3,월','3개월'],
                ['4,월','4개월'], ['5,월','5개월'], ['6,월','6개월'],
            ];
            for( const [v,t] of months) h += `<div class="item flex _day_" data-value="${v}">${t}</div>`;
            return h;
        })();
        const moreTonItems = [1, 2.5, 5, 6, 7.5, 10, 12.5, 15, 17.5, 20]
            .map(v=>`<div class="item flex _ton_" data-value="${v},톤">${v}톤짐</div>`).join('');
        const moreHourItems = (()=>{
            let h=''; for(let i=1;i<=12;i++) h+=`<div class="item flex _hour_" data-value="${i},시간">${$j.F.Car.hourLabel(i, car_type)}</div>`; return h;
        })();
        const moreNightItems = (()=>{
            let h=''; for(let i=1;i<=12;i++) h+=`<div class="item flex _night_" data-value="${i},야간">${$j.F.Car.hourLabel(i, car_type)}</div>`; return h;
        })();

        return `
<div id="window-howlong" class="order_time">
<div class="order_grid ladder">${standardSection}${dayBoxSection}
</div>

<div id="more_ton_pop" class="more_pop">
    <div class="more_grid">${moreTonItems}</div>
</div>

<div id="more_day_pop" class="more_pop">
    <div class="more_grid">${moreDayItems}</div>
</div>

<div id="more_hour_pop" class="more_pop">
    <div class="more_grid">${moreHourItems}</div>
</div>

<div id="more_night_pop" class="more_pop">
    <div class="more_grid">${moreNightItems}</div>
</div>

<div id="available_times" data-value="${available_times}"></div>
</div>`;
    }
    init = function() {
        this.parent.setTitle('작업소요');
        $('#' + this.id).html(this.getHtml(this.data));
        this.initData();
        this.draw();
        this.initHandler();
        if( this.data['car_type']=='사다리') {
            $j.Ui.Toast.show('사다리차 이용기준중 하나를 선택해주세요.', { type:'warning', timeout:3000, closable:true });
        }
    }
    destroy() {
        // 더보기 창이 열린 채 시트가 닫히면 팝업 노드가 모달 안에 남는다 — 먼저 되돌린다
        this.moreModal?.close();
        $('#window-howlong').off();
    }
    initData(){
        this.std='h';
        // 기준이 뭐냐? 톤수냐 시간이냐? 사다리일때만 기본값이 톤수, 그외에는 시간
        if( this.data['car_type']=='사다리') {
            this.std='t';
            if( this.data['car_workdaytype'] && this.data['car_workdaytype']!='톤') this.std='h';
        }
    }
    /**
     * 이벤트 핸들러등록
     * off -> on 하는 이유는 윈도우여러번 닫았다 띄웠다 하면 핸들러가 중첩될수있기때문에 기존핸들러를 제거하기위함이다.
     */
    initHandler = function(){
        const self = this;

        // 기준 선택버튼 클릭 핸들러 ( 사다리일때만 동작하게 )
        $('#window-howlong .standard_btn').off().on('click',function(e){
            if( self.data['car_type']!='사다리') return;

            if( $(this).data('value')=='t') {
                // console.log('톤수 기준 클릭');
                self.std='t';
                self.draw();
            }
            else {
                // console.log('시간 기준 클릭');
                self.std='h';
                self.draw();
            }

        });

        // 더보기 — 팝업을 '노드째' 모달 안으로 옮긴다.
        // 아래 .item 핸들러는 init 시점에 요소에 직접 걸리므로(위임 아님), 노드를 옮겨도
        // 핸들러가 함께 따라간다. HTML 을 다시 그리면 그 핸들러가 사라져 항목이 안 눌린다.
        // (구 jquery-modal 도 .modal 을 body 의 blocker 로 옮기는 방식이라 같은 전제였다)
        $('#window-howlong .more-open').off().on('click',function(e){
            e.preventDefault();
            const $pop  = $('#' + $(this).data('pop'));
            const $home = $pop.parent();
            self.moreModal = $j.Ui.Modal.open({
                mode: 'center', variant: 'mobile', panelClass: 'more_modal',
                title: $(this).data('title'),
                html: '',
                onClose: () => { $pop.hide().appendTo($home); self.moreModal = null; },
            });
            self.moreModal.el.find('.ui-modal__body').append($pop.show());
        });

        // 톤, 시간 선택 버튼
        // :not(.more-open) 필수 — 더보기 링크도 .item 을 달고 있어서, 여기 .off() 가
        // 위에서 건 더보기 핸들러까지 걷어간다(인자 없는 off 는 그 요소의 핸들러를 전부 지운다).
        $('#window-howlong .item').not('.more-open').off().on('click',function(e){
            if( !$(this).is('div') || !$(this).attr('data-value') || $(this).hasClass('disabled') || $(this).parent().parent().hasClass('disabled') ) return;

            let [car_workhour,car_workdaytype] = $(this).attr('data-value').split(',');

            if( self.data.$p.editMode!='myorderedit' ) {// 수정모드가 아닐때만
                if (Util.isSosokSamsung(self.data['order_sosok']) && car_workhour == 3 && car_workdaytype == '시간') {
                    car_workhour = 4;
                    const h3 = $j.F.Car.hourLabel(3, self.data['car_type']);
                    const h4 = $j.F.Car.hourLabel(4, self.data['car_type']);
                    alert(`${h3}은 ${h4}으로 변경되어 발주됩니다.\n(${h3} 과 ${h4}의 장비 단가 같음)`);
                }
            }

            self.data['car_workdaytype']=car_workdaytype;
            self.data['car_workhour']=car_workhour;

            self.draw();
            self.apply();
        });
    }
    /**
     * 화면 업데이트
     */
    draw = function(){
        const self=this;
        const selHowlong = self.data['car_workhour']+','+self.data['car_workdaytype'];

        if( self.data['car_type']=='사다리'){
            // 기준 버튼 ( 사다리일때만 표시, 그외에는 비공개 )
            $('#window-howlong .standard_btn').each(function(idx,el){
                if( $(el).data('value')==self.std ) $(el).addClass('on');
                else $(el).removeClass('on');
            });
            // 영역 전체 disable ( 사다리일때만 )
            if( self.std=='t'){
                $('#window-howlong .weight_box').removeClass('disabled');
                $('#window-howlong .day_box').addClass('disabled');
            }else{
                $('#window-howlong .weight_box').addClass('disabled');
                $('#window-howlong .day_box').removeClass('disabled');
            }

        }else{
            $('#window-howlong .standard_box').hide();
        }

        // 전체 버튼 disabled 시키기
        $('#window-howlong .item').each(function(idx,el){
            // if( !$(this).is('div') || !$(this).attr('data-value')) return;

            $(this).addClass('disabled').removeClass('on');

            // 선택한 버튼은 on 시키기
            if( selHowlong==$(this).attr('data-value')) {
                $(this).addClass('on');
            }

        });

        // 버튼 enable 시키기
        const typeToClassList = {
            '일': '_day_',
            '오전': '_half_',
            '오후': '_half_',
            '시간': '_hour_',
            '야간': '_night_',
            '톤': '_ton_'
        };
        const arr = $('#available_times').attr('data-value').split(',');
        arr.push('톤');// 톤은 무조건 활성화
        arr.forEach((v)=>{
            const clss = typeToClassList[v];
            $('#window-howlong .'+clss).removeClass('disabled');
        });

    }
    apply = function(){
        this.moreModal?.close();// 더보기 창이 열려 있었다면 닫는다
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
}
